var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleDrive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 40,
    viewBox: "0 0 45 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.4186 27.1021H14.1363L7.16406 39.2807C8.00284 39.7072 8.95535 39.9806 9.5714 39.9806C15.9764 39.9806 29.0481 39.8858 35.537 39.8858C36.2042 39.8858 36.8288 39.6584 37.389 39.302L30.4186 27.1021Z",
    fill: "#4185F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.16209 39.282L14.1343 27.103H0.00598261C-0.00112563 27.9494 0.29979 28.7237 0.771304 29.6071C2.08491 32.0646 4.30742 35.9932 5.61297 38.0451C5.93473 38.5508 7.21232 39.3076 7.16209 39.282Z",
    fill: "#1767D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.418 27.102L37.3907 39.3002C38.2943 38.7258 39.0308 37.816 39.5089 36.9782C40.5884 35.0888 42.4138 31.9427 43.6729 29.8126C44.2581 28.8222 44.4856 27.9327 44.4714 27.1011L30.418 27.102Z",
    fill: "#E94235"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1379 27.1036L22.2707 12.9648L15.0023 0.84668C14.2161 1.36369 13.5437 2.06551 13.2385 2.60005C10.0658 8.16438 3.67449 19.5684 0.460597 25.2047C0.131274 25.7815 -0.0264009 26.4403 0.00613997 27.1036H14.1379Z",
    fill: "#30A753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.417 27.1035L22.2695 12.9647L29.3384 0.860352C30.1246 1.37783 30.9876 2.06544 31.2927 2.60045C34.4654 8.16431 40.8566 19.5683 44.0719 25.2047C44.4037 25.7842 44.5036 26.4401 44.4714 27.1035H30.417Z",
    fill: "#F9BC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 0.848328L22.2694 12.9646L29.3384 0.860175C28.6086 0.43368 27.575 0.181101 26.5742 0.149351C23.7896 0.0564695 19.2754 0.0190328 16.8458 0.124709C16.2468 0.150772 15.0076 0.843115 15 0.848328Z",
    fill: "#0F8038"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.5038,
    height: 40,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleDrive);
export default __webpack_public_path__ + "static/media/google-drive.cf7ddce2a8f433d1271d8c03bb66042f.svg";
export { ForwardRef as ReactComponent };